/* requires:
polyfill.js
*/

const generateEmarsysUrl = (formFields, formId) => {
  const emarsysFormId = `f=${formId}&`,
    // All form fields with Emarsys IDs
    inp_1 = formFields.first_name ? `inp_1=${formFields.first_name}&` : '',
    inp_2 = formFields.last_name ? `inp_2=${formFields.last_name}&` : '',
    inp_3 = formFields.email ? `inp_3=${formFields.email}&` : '',
    inp_9 = formFields.title ? `inp_9=${formFields.title}&` : '',
    inp_11 = formFields.city ? `inp_11=${formFields.city}&` : '',
    inp_12 = formFields.state ? `inp_12=${formFields.state}&` : '',
    inp_13 = formFields.zip ? `inp_13=${formFields.zip}&` : '',
    inp_15 = formFields.phone ? `inp_15=${formFields.phone}&` : '',
    inp_18 = formFields.company ? `inp_18=${formFields.company}&` : '',
    // referring URL
    inp_2718 = formFields['00N1T00000AXeke'] ? `inp_2718=${formFields['00N1T00000AXeke']}&` : '',
    // source URL
    inp_2721 = formFields['00N1T00000AXel8'] ? `inp_2721=${formFields['00N1T00000AXel8'].split('#')[0]}&` : '',
    // web_form
    inp_2722 = formFields['web_form'] ? `inp_2722=${formFields['web_form']}&` : '',
    // Lead Source
    inp_2723 = formFields['lead_source'] ? `inp_2723=${formFields['lead_source']}&` : '',
    // lead_status
    inp_2725 = formFields['status'] ? `inp_2725=${formFields['status']}&` : '',
    // source domain
    inp_2726 = formFields['00N1T00000AXel3'] ? `inp_2726=${formFields['00N1T00000AXel3']}&` : '',
    // gclid
    inp_2728 = formFields['00N1T00000AXef3'] ? `inp_2728=${formFields['00N1T00000AXef3']}&` : '',
    inp_2809 = formFields.state ? `inp_2809=${formFields.state}&` : '',
    // bing lead
    inp_17832 = formFields['00N1T00000AXfJP'] ? `inp_17832=${formFields['00N1T00000AXfJP']}&` : '',
    // facebook lead
    inp_17833 = formFields['00N1T00000AXef2'] ? `inp_17833=${formFields['00N1T00000AXef2']}&` : '',
    // clientID
    inp_18500 = formFields.client_number ? `inp_18500=${formFields.client_number}&` : '',
    // message
    inp_22127 = formFields.message ? `inp_22127=${formFields.message}&` : '',
    // training needs or message
    inp_22194 = formFields['00N1T00000Axl4O'] ? `inp_22194=${formFields['00N1T00000Axl4O']}&` : '',
    // language
    inp_22195 = formFields['00N1T00000Aaegz'] ? `inp_22195=${formFields['00N1T00000Aaegz']}&` : '',
    // submission form industry state
    inp_22196 = formFields['00N1T00000Aaegp'] ? `inp_22196=${formFields['00N1T00000Aaegp']}&` : '',
    // exam type
    inp_23427 = formFields['00N1T00000Aaegu'] ? `inp_23427=${formFields['00N1T00000Aaegu']}&` : '',
    // Number of Employees
    inp_24248 = formFields['00N50000001KVIK'] ? `inp_24248=${formFields['00N50000001KVIK']}&` : '',
    // County
    inp_30680 = formFields.county ? `inp_30680=${formFields.county}&` : '',
    // Reason
    inp_32640 = formFields.refund_reason ? `inp_32640=${formFields.refund_reason}&` : '',
    // Transaction Amount
    inp_32641 = formFields.transaction_amount ? `inp_32641=${formFields.transaction_amount}&` : '',
    // Transaction Date
    inp_32642 = formFields.transaction_date ? `inp_32642=${formFields.transaction_date}&` : '';

  const emarsysFormUrl =
    'https://link.theuniversityplatform.com/u/register.php?CID=817427910&p=2&a=r&SID=&el=&llid=&counted=&c=&optin=y&' +
    emarsysFormId +
    inp_1 +
    inp_2 +
    inp_3 +
    inp_9 +
    inp_11 +
    inp_12 +
    inp_13 +
    inp_15 +
    inp_18 +
    inp_2718 +
    inp_2721 +
    inp_2722 +
    inp_2723 +
    inp_2725 +
    inp_2726 +
    inp_2728 +
    inp_2809 +
    inp_17832 +
    inp_17833 +
    inp_18500 +
    inp_22194 +
    inp_22127 +
    inp_22195 +
    inp_22196 +
    inp_23427 +
    inp_24248 +
    inp_30680 +
    inp_32640 +
    inp_32641 +
    inp_32642;

  return emarsysFormUrl;
};

const leadForm = {
  init: function (formSetting) {
    const { theForm } = formSetting;
    if (!theForm) {
      return false;
    }
    this.validateOnBlur(theForm);

    // listening for click on the submit button
    const submitBtn = theForm.querySelector('button[type=submit]') || theForm.querySelector('input[type=submit]');
    submitBtn.addEventListener(
      'click',
      function (e) {
        e.preventDefault();
        const isFormValid = leadForm.isFormValid(theForm);
        if (!isFormValid) {
          // theForm.querySelector('.validation-msg').classList.remove('d-none');
          return false;
        } else {
          leadForm.submit(formSetting);
        }
      },
      true
    );
  },
  validateOnBlur: function (theForm) {
    if (!theForm) {
      return false;
    }
    // realtime form fields validation using blur event
    const fields = theForm.querySelectorAll('.required');
    for (let field of fields) {
      const type = field.type;
      if (type === 'email') {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            const re =
              /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            if (!re.test(x)) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      } else if (type === 'tel') {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
            if (!re.test(x)) {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      } else {
        field.addEventListener(
          'blur',
          function (e) {
            const x = field.value;
            if (!x || x.trim() == '') {
              field.classList.add('is-invalid');
            } else {
              field.classList.remove('is-invalid');
            }
          },
          true
        );
      }
    }
  },
  isFormValid: function (theForm) {
    if (!theForm) {
      return false;
    }
    // form fields validation during submission
    const fields = theForm.querySelectorAll('.required');
    let isFormValid = true;
    for (let field of fields) {
      const type = field.type;
      if (type === 'email') {
        const x = field.value;
        const re =
          /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if (!re.test(x)) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      } else if (type === 'tel') {
        const x = field.value;
        const re = /[(]?\d{3}[)]?\s?-?\s?\d{3}\s?-?\s?\d{4}/;
        if (!re.test(x)) {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      } else {
        const x = field.value;
        if (!x || x.trim() == '') {
          field.classList.add('is-invalid');
          isFormValid = false;
        } else {
          field.classList.remove('is-invalid');
        }
      }
    }
    return isFormValid;
  },
  submit: function (formSetting) {
    const { theForm, emarsysFormId } = formSetting;
    const submitBtn = theForm.querySelector('button[type=submit]');

    const readCookie = (name) => {
      let nameEQ = escape(name) + '=';
      let ca = document.cookie.split(';');
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
      }
      return null;
    };

    const referringUrl = document.referrer || '';
    const sourceUrl = window.location.href || '';
    const sourceDomain = 'https://' + window.location.host || '';
    const adwordsLead = readCookie('adwordsLead') || '';
    const facebookLead = readCookie('facebookLead') || '';
    const bingLead = readCookie('bingLead') || '';
    const clientID = readCookie('_ga') ? readCookie('_ga').split('.').slice(2).join('.') : '';

    theForm.querySelector('input.refurl').value = referringUrl;
    theForm.querySelector('input.source_url').value = sourceUrl;
    theForm.querySelector('input.source_domain').value = sourceDomain;
    // theForm.querySelector('input.leaduuid').value = leaduuid;
    theForm.querySelector('input.gclid').value = adwordsLead;
    theForm.querySelector('input.facebookLead').value = facebookLead;
    theForm.querySelector('input.bingLead').value = bingLead;
    theForm.querySelector('input.clientID').value = clientID;
    // setting the return URL after we post the data to Emarsys, this will give us control of the return URL inside this script
    //theForm.querySelector('input[name="retURL"]').value = `${window.location.protocol}//${window.location.host}/thanks/`;

    const hiddenFields = [];
    const formRawData = new FormData(theForm);

    // generate form fields data for submission
    const fields = [...hiddenFields];
    for (let pair of formRawData.entries()) {
      // console.log(pair[0]+ ', '+ pair[1]);
      const keyValues = {
        name: pair[0],
        value: pair[1],
      };
      fields.push(keyValues);
    }

    // form fields key-value pairs
    const formFields = fields.reduce((fieldObject, field) => {
      fieldObject[field.name] = field.value;
      return fieldObject;
    }, {});

    // const formActionUrl = 'https://webto.salesforce.com/servlet/servlet.WebToLead?encoding=UTF-8';

    function sendToEmarsysViaPost() {
      submitBtn.innerHTML = 'Submitting...';
      // listen to onformdata event that is fired when the form is submitted
      // we use this to modify the form data before it get submitted to SF
      theForm.onformdata = (e) => {
        const formData = e.formData;
        // modifies the form data to add the rest of the data needed
        for (let [key, value] of formRawData) {
          // set or update form fields wth values
          formData.set(key, value);
        }
      };

      // submit to Emarsys via fetching the page then submit form to SF
      const emarsysUrl = generateEmarsysUrl(formFields, emarsysFormId) || '';
      fetch(emarsysUrl, {
        method: 'POST',
        mode: 'no-cors',
      })
        .then((response) => response.text())
        .then((data) => {
          // theForm.action = formActionUrl;

          // a simple theForm.submit() doesn't work because we have name=submit in one of the input which override the submit() function on the form
          // const submitFormFunction = Object.getPrototypeOf(theForm).submit;
          // submitFormFunction.call(theForm);

          if (emarsysFormId == '3288') {
            window.location.href = `${window.location.protocol}//${window.location.host}/terms-and-conditions/?sent=1`;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          console.error('Error:', error.data);
        });
    }
    sendToEmarsysViaPost();
  },
};

// This is how to initialize the form processor script within the page that uses this
// const formSetting = {
//   theForm: document.querySelector('form.leadform'),
//   emarsysFormId: 2680,
// }
// leadForm.init(formSetting)
